import { net_api_url } from 'components/Store';
import axios from 'axios';
const makePlanCompliant = async (getAccessToken, user, source) => {
  try {
    let token = await getAccessToken();
    let planCompliant = await axios.post(
      `${net_api_url}/api/subscription/make-plan-compliant`,
      {
        userId: user.sub,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        signal: source?.signal,
      }
    );
    return planCompliant.data;
  } catch (error) {
    if (error.name === 'CanceledError') {
      console.error(error?.config?.signal?.reason);
    } else {
      console.error(error);
    }
  }
};

export default makePlanCompliant;
